import { isUnknownObject } from '~/shared/utils/guards'
import { BaseModel, convertToArrayModels, fillOwnProperties, registerModel } from '~/shared/model'
import { toCroppedImage } from '~/shared/utils/image'
import { VacancyNewCardModel } from '~/models/cards'

export default class AgrocityModel extends BaseModel {
  static override constructorName = 'AgrocityModel'

  id: number = 0
  name: string = ''
  region: string = ''
  'region_id': string = ''
  'region_slug': string = ''
  'city_slug': string = ''
  'brief_description': string = ''
  'temperature': number = 0
  'humidity': number = 0
  'wind_speed': number = 0
  'longitude': number = 0
  'latitude': number = 0
  'average_salary': number = 0
  'rent_cost': number = 0
  'population': number = 0
  'life_expectancy': number = 0
  'population_description': string = ''
  'standard_of_living': string = ''
  'history': string = ''
  'infrastructure': string = ''
  'education': string = ''
  'nature': string = ''
  'economy': string = ''
  'culture': string = ''
  'main_photo': string = ''
  'main_photo_preview': string = ''
  'nature_photo_1': string = ''
  'nature_photo_2': string = ''
  'created_at': string = ''
  'updated_at': string = ''
  vacancies: VacancyNewCardModel[] = []
  'vacancies_url': string = ''
  'similar_agrocities': AgrocityModel[] = []
  'agrocity_url': string = ''

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)

      this.main_photo = toCroppedImage(data.main_photo, { width: 1440, quality: 75 })
      this.main_photo_preview = toCroppedImage(data.main_photo, { width: 480, quality: 75 })
      this.nature_photo_1 = toCroppedImage(data.nature_photo_1, { width: 600, quality: 80 })
      this.nature_photo_2 = toCroppedImage(data.nature_photo_2, { width: 600, quality: 80 })

      this.vacancies = convertToArrayModels(data.vacancies, VacancyNewCardModel)
      this.similar_agrocities = convertToArrayModels(data.similar_agrocities, AgrocityModel)
    }
  }
}

registerModel(AgrocityModel)
